import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type VesselTypesRequest = CommonTableRequest;

export interface VesselType {
    id: number;
    type: string;
    shortCode: string;
}

export interface VesselTypes {
    id: number;
    vesselTypeId: number;
    type: string; // VesselSub Type
    shortCode: string; // SubType Code
    vesselType: VesselType; // VesselType
    vesselTypeType: string;
    vesselTypeShortCode: string;
    isActive: boolean;
    builtIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface VesselTypesResponse {
    data: VesselTypes[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface UpdateVesselTypesRequest {
    isActive: boolean;
}

export type VesselTypesUpdateResponse = VesselTypes;

export const getApiVesselTypes = (
    clientId: number,
    tenantAlias: string,
    payload: VesselTypesRequest,
): Promise<VesselTypesResponse> =>
    httpApi
        .post<VesselTypesResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-types/search`,
            payload,
        )
        .then(({ data }) => data);

export const updateApiVesselTypes = (
    clientId: number,
    tenantAlias: string,
    id: number, // here use id from VesselTypes but not vesselTypeId
    payload: UpdateVesselTypesRequest,
): Promise<VesselTypesUpdateResponse> =>
    httpApi
        .put<VesselTypesUpdateResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-types/${id}`,
            payload,
        )
        .then(({ data }) => data);
